import server from '../../api/server'

const state = {
  settings: {}
}

// getters
const getters = {
  getOpenSettings: state => state.settings
}

// actions
const actions = {
  fetchOpenSettings ({commit, state}) {
    server.openApiGet(
      '/openapi/settings',
      (data) => {
        commit('setOpenSettings', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении текущей конфигурации клиента '})
      }
    )
  }
}

// mutations
const mutations = {
  setOpenSettings (state, data) {
    state.settings = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/open.js